import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Loader2, LogOut, AlertCircle } from 'lucide-react'

interface LeaveGroupDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  groupName: string
  onLeave: () => void
  loading: boolean
  error: string | null
}

export function LeaveGroupDialog({
  open,
  onOpenChange,
  groupName,
  onLeave,
  loading,
  error,
}: LeaveGroupDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Leave {groupName}?</DialogTitle>
          <DialogDescription>
            Are you sure you want to leave this group? You'll lose access to all leagues and matches in this group. You can rejoin later if you receive a new invite.
          </DialogDescription>
        </DialogHeader>
        
        {error && (
          <div className="rounded-md bg-destructive/10 border border-destructive/20 p-3 flex items-center gap-2 text-sm text-destructive">
            <AlertCircle className="h-4 w-4 shrink-0" />
            <span>{error}</span>
          </div>
        )}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false)
            }}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onLeave}
            disabled={loading}
          >
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                Leaving...
              </>
            ) : (
              <>
                <LogOut className="h-4 w-4 mr-2" />
                Leave Group
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
